/* eslint import/no-unresolved: 0 */
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Icon, IconButtonWithTooltip, Stack } from '@openedx/paragon';
import { Locked } from '@openedx/paragon/icons';

import SequenceTitle from '@src/course-home/outline-tab/section-outline/SequenceTitle';
import messages from './messages';
import { UNLOCKED } from './constants';

const SequenceHeader = ({
  complete,
  id,
  lockedStatus,
  sequence,
  showLink,
  title,
}) => {
  const intl = useIntl();
  const isLocked = lockedStatus !== UNLOCKED;

  return (
    <Stack direction="horizontal" gap={2}>
      <SequenceTitle
        {...{
          complete,
          showLink,
          title,
          sequence,
          id,
        }}
      />
      {isLocked && (
        <IconButtonWithTooltip
          tooltipPlacement="top"
          src={Locked}
          tooltipContent={(
            <span>
              {intl.formatMessage(messages.sequenceTooltipContent, { lockedStatus })}
            </span>
          )}
          variant="primary"
          iconAs={Icon}
        />
      )}
    </Stack>
  );
};

SequenceHeader.propTypes = {
  complete: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  lockedStatus: PropTypes.string.isRequired,
  sequence: PropTypes.shape().isRequired,
  showLink: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default SequenceHeader;
